import { render, staticRenderFns } from "./store-card.vue?vue&type=template&id=1d262439&scoped=true&"
import script from "./store-card.vue?vue&type=script&lang=js&"
export * from "./store-card.vue?vue&type=script&lang=js&"
import style0 from "./store-card.vue?vue&type=style&index=0&id=1d262439&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d262439",
  null
  
)

export default component.exports